import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';
import moment from 'moment';

// services
import * as OplevAltService from '../../../../services/bb-api/oplevalt/dashboard';
import type { SalesType } from '../../../../services/bb-api/oplevalt/dashboard';

export const LatestSales: React.FC = () => {
	const [latestSales, setLatestSales] = useState<SalesType[]>([]);

	const getData = useCallback(() => {
		try {
			OplevAltService.latestSales().then(setLatestSales);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 60 seconds
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	return (
		<StyledContainer className='sales'>
			{/* Latest sales */}
			<div className='flex-item'>
				<div className='sales-container'>
					{latestSales.map((sale, index) => (
						<div className='sale-item' key={index}>
							<p className='username'>{sale.firstName}</p>
							<p className='city'>{sale.city}</p>
							<p className='title'>{sale.title}</p>
							<p className='persons'>{sale.persons ? sale.persons : '-'} <span className='light-grey'>{sale.persons ? ' personer' : null}</span></p>
							<p className='price'>{sale.price.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} <span className='currency'>DKK</span></p>
							<p className='sale-created'>{moment(sale.created).format('DD-MM-YYYY HH:mm')}</p>
						</div>
					))}
				</div>
			</div>
		</StyledContainer>
	);
};

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: #9ca3af;
	width: 100%;
	
	.flex-item {
		display: flex;
	}
	
	.sales-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		background-color: rgba(31, 41, 55, 1);
		margin: 1em;
		padding: 12px 48px;
		border-radius: 12px;
		box-shadow: rgba(0,0,0,0.2) 0px 2px 8px 0px;
	}

	h1 {
		font-size: 84px;
		font-weight: 700;
		line-height: 1em;
		color: #ffffff;
		margin: 0;
	}

	p {
		margin: 0;
	}
	
	.sale-item {
		display: flex;
		padding: 12px 0;
		gap: 36px;
		color: #ffffff;
		
		p {
			font-size: 20px;
			font-weight: bold;
		}
	}
	
	.sale-item + .sale-item {
		border-top: 1px solid #394350;
	}

	.username {
		width: 240px;
	}

	.city {
		width: 180px;
	}

	.title {
		width: 500px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 48px;
	}

	.persons {
		width: 160px;
	}

	.price {
		width: 150px;
		text-align: right;
	}

	.currency {
		color: #9ca3af;
		padding-left: 6px;
	}

	.sale-created {
		width: 200px;
		text-align: right;
	}

	.light-grey {
		color: #9ca3af;
	}
`;
